import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const planUpsellRoute: InvariantJiraRoute = {
	name: 'software-plan-upsell',
	path: '/jira/plans/getting-started',
};
